import { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
} from '@material-ui/core'
import { Add as AddIcon } from '@material-ui/icons'
import { Controller, useForm } from 'react-hook-form'

import { useFetch, useSnackbar } from 'hooks'
import { MenuButton } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import helpers from 'helpers'
import * as service from 'service'

import schema from './schema'

const BillingEmails = ({ paymentServiceTemplateId }) => {
  const snackbar = useSnackbar()
  const [loading, setLoading] = useState(false)

  const { control, handleSubmit, errors, reset } = useForm({
    validationSchema: schema,
    defaultValues: { email: '' },
  })

  const { response, isLoading, refresh } = useFetch(
    service.dponet.billingEmails.index,
    { entityIdEq: paymentServiceTemplateId, entityTypeEq: 'PaymentService' },
    [],
  )

  const billingEmails = (!isLoading && response?.data?.billingEmails) || []

  const onSubmit = async (data) => {
    setLoading(true)
    try {
      await service.dponet.paymentServiceTemplates.createBillingEmail({
        paymentServiceTemplateId,
        email: data.email.toLowerCase(),
      })
      snackbar.open({
        message: 'E-mail adicionado com sucesso!',
        variant: 'success',
      })
      reset({ email: '' })
      refresh()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Falha ao adicionar o e-mail.',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleRemove = async (billingEmailId) => {
    setLoading(true)
    try {
      await service.dponet.paymentServiceTemplates.destroyBillingEmail({
        paymentServiceTemplateId,
        billingEmailId,
      })
      snackbar.open({
        message: 'E-mail excluído com sucesso!',
        variant: 'success',
      })
      refresh()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Falha ao excluir o e-mail.',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box mt={2}>
      <form id="id-add-email-payment-service-template">
        <Grid container spacing={2}>
          <Grid item xs={10}>
            <Controller
              control={control}
              name="email"
              mode="onChange"
              as={
                <TextField
                  type="email"
                  label="E-mail de notificação"
                  fullWidth
                  variant="outlined"
                  error={!!errors?.email}
                  helperText={errors?.email?.message}
                  disabled={loading}
                />
              }
            />
          </Grid>
          <Grid item xs={2}>
            <Button
              form="id-add-email-payment-service-template"
              fullWidth
              startIcon={
                loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : (
                  <AddIcon />
                )
              }
              disabled={loading}
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
            >
              Adicionar
            </Button>
          </Grid>
        </Grid>
      </form>
      <Box mt={2}>
        <Table
          size="small"
          stickyHeader
          isLoading={isLoading}
          emptyMessage="Nenhum e-mail cadastrado"
        >
          <TableHead>
            <TableRow>
              <TableCell width="20%">Identificador</TableCell>
              <TableCell width="60%">E-mail</TableCell>
              <TableCell width="20%" align="right">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {billingEmails?.map((emailObject) => (
              <TableRow hover key={emailObject?.id}>
                <TableCell disableTooltip>{emailObject?.id}</TableCell>
                <TableCell noOverFlow>{emailObject?.email}</TableCell>
                <TableCell disableTooltip align="right">
                  <MenuButton>
                    <Button
                      onClick={() => handleRemove(emailObject?.id)}
                      fullWidth
                      size="small"
                    >
                      Excluir
                    </Button>
                  </MenuButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  )
}

BillingEmails.propTypes = {
  paymentServiceTemplateId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
}

export default BillingEmails
